import clsx from 'clsx'
import React from 'react'

interface Props {
  className?: string
  loading?: 'lazy' | 'eager'
  priority?: 'auto' | 'high' | 'low'
  variant?: 'dark' | 'light'
  width?: string | number
  height?: string | number
  isArabic?: boolean
}

export const Logo = ({
  isArabic,
  loading: loadingFromProps = 'lazy',
  priority: priorityFromProps = 'low',
  className,
  variant = 'dark',
  width,
  height,
}: Props) => {
  const src = isArabic
    ? variant === 'light'
      ? '/logo/ccsm-logo-2.svg'
      : '/logo/ccsm-logo-4.svg'
    : variant === 'light'
      ? '/logo/ccsm-logo-1.svg'
      : '/logo/ccsm-logo-3.svg'

  const defaultWidth = '150px' // 9.375rem
  const defaultHeight = '38px'

  return (
    <img
      alt="Payload Logo"
      loading={loadingFromProps}
      fetchPriority={priorityFromProps}
      decoding="async"
      className={clsx('block', className)}
      src={src}
      // style={{
      //   maxWidth: typeof width === 'number' ? `${width}px` : width || defaultWidth,
      //   height: typeof height === 'number' ? `${height}px` : height || defaultHeight,
      // }}
    />
  )
}
